import { createComboboxItemStore } from "./createComboboxItemStore.js";
import { createContext } from "react";
import Fuse from "fuse.js";
//#region src/combobox/ComboboxContext.tsx
const initializationNoOp = () => {};
const ComboboxContext = createContext({
	selectedItems: [],
	setSelectedItems: initializationNoOp,
	isOpen: false,
	setIsOpen: initializationNoOp,
	isError: false,
	query: "",
	setQuery: initializationNoOp,
	useLocalSearch: true,
	setUseLocalSearch: initializationNoOp,
	searchResults: [],
	setSearchResults: () => {},
	searchInstance: new Fuse([]),
	experimentalReactiveItems: false,
	experimentalItemStore: createComboboxItemStore(),
	searchRef: { current: null },
	listRef: { current: null },
	listId: "",
	lastClickedItemRef: { current: null },
	resource: "item",
	plurality: "s",
	allowMultiple: true,
	allowUnselect: true,
	disabled: false,
	popoverProps: {},
	triggerRef: void 0
});
const ComboboxItemContext = createContext({
	value: "",
	isSelected: false,
	disabled: false
});
//#endregion
export { ComboboxContext, ComboboxItemContext };
